import React, { useEffect, useState } from "react";
import {
  Card,
  Input,
  List,
  Avatar,
  Button,
  Space,
  Typography,
  Spin,
} from "antd";
import { User, Send } from "lucide-react";
import dayjs from "dayjs";
import { notificationErroInternalGeneric } from "util/api-utils";
import {
  getComments,
  saveComments,
} from "services/managerial/managerial-service";

const { TextArea } = Input;
const { Text } = Typography;

export default function HistoricCommentBox({ companyId }) {
  const [loading, setLoading] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [comments, setComments] = useState("");
  const urlParam = `${companyId}/comment`;

  const handleSend = async () => {
    if (!newComment.trim()) return;

    setLoading(true);
    try {
      const commentData = {
        message: newComment.trim(),
      };
      await saveComments(urlParam, commentData);
      setNewComment("");
      await getCommentsData();
    } catch (error) {
      notificationErroInternalGeneric();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!companyId) return;

    getCommentsData();
  }, [companyId]);
  const getCommentsData = async () => {
    setLoading(true);
    try {
      const result = await getComments(urlParam);
      setComments(result);
    } catch (error) {
      notificationErroInternalGeneric();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <Card
        size="small"
        title="Histórico"
        style={{ marginTop: 20 }}
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          height: 400,
          overflow: "hidden",
          padding: 12,
        }}
      >
        <div
          style={{ flex: 1, overflowY: "auto", paddingRight: 4 }}
          className="custom-scroll"
        >
          <List
            dataSource={comments}
            locale={{ emptyText: "Nenhum comentário" }}
            renderItem={(item) => (
              <List.Item style={{ padding: "12px 0" }}>
                <List.Item.Meta
                  avatar={
                    <Avatar
                      src={item.userImg || undefined}
                      size={48}
                      style={{
                        backgroundColor: "#e6f4ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {!item.userImg && <User size={20} />}
                    </Avatar>
                  }
                  title={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>{item.userName}</span>
                      <span style={{ fontSize: 12, color: "#999" }}>
                        {dayjs(item.createdAt).format("DD/MM/YYYY HH:mm")}
                      </span>
                    </div>
                  }
                  description={
                    <div style={{ marginTop: 4, whiteSpace: "pre-wrap" }}>
                      {item.message}
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        </div>

        <div
          style={{
            borderTop: "1px solid #f0f0f0",
            paddingTop: 12,
            marginTop: 12,
          }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <TextArea
              rows={3}
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              placeholder="Escreva um comentário..."
              onPressEnter={(e) => {
                if (!e.shiftKey) {
                  e.preventDefault();
                  handleSend();
                }
              }}
            />
            <Button
              type="primary"
              icon={
                <Send
                  size={16}
                  style={{ marginBottom: "-3px", marginRight: "5px" }}
                />
              }
              onClick={handleSend}
              disabled={!newComment.trim()}
            >
              Enviar
            </Button>
          </Space>
        </div>
      </Card>
    </Spin>
  );
}
